import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Agenda\StoreEventController::__invoke
* @see app/Http/Controllers/Agenda/StoreEventController.php
* @route '/api/agenda/store-event'
*/
const StoreEventController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreEventController.url(options),
    method: 'post',
})

StoreEventController.definition = {
    methods: ["post"],
    url: '/api/agenda/store-event',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Agenda\StoreEventController::__invoke
* @see app/Http/Controllers/Agenda/StoreEventController.php
* @route '/api/agenda/store-event'
*/
StoreEventController.url = (options?: RouteQueryOptions) => {
    return StoreEventController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\StoreEventController::__invoke
* @see app/Http/Controllers/Agenda/StoreEventController.php
* @route '/api/agenda/store-event'
*/
StoreEventController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreEventController.url(options),
    method: 'post',
})

export default StoreEventController